module.exports = __webpack_public_path__ + "static/media/homeBackground.abf7a1da.svg";